import React from "react";
import SubscriptionOffer from "./SubscriptionOffer";

const SubscribeModal = (props) => {
  const { hideModal } = props || {};
  return <SubscriptionOffer mode="modal" hideModal={hideModal} />;
};

export default SubscribeModal;
